var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2956 4.9347V22.7454C12.2956 24.0413 11.245 25.0918 9.94915 25.0918C8.95752 25.0918 8.07293 24.4685 7.73941 23.5346L4.87753 15.3357M4.87753 15.3357C2.96797 14.5239 1.62891 12.6309 1.62891 10.4251C1.62891 7.47961 4.01672 5.0918 6.96223 5.0918H9.40501C14.8725 5.0918 19.5714 3.44633 21.6289 1.0918V19.7585C19.5714 17.4039 14.8725 15.7585 9.40501 15.7585H6.96221C6.22248 15.7585 5.51793 15.6078 4.87753 15.3357ZM21.6289 14.4251C23.8381 14.4251 25.6289 12.6343 25.6289 10.4251C25.6289 8.216 23.8381 6.42513 21.6289 6.42513",
    stroke: "#232222",
    strokeWidth: 1.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.a69a5e073c29b102878f9c076cc399f5.svg";
export { ForwardRef as ReactComponent };